(() => {
  'use strict';
  if (window.__flaviaCardMinimum) return;
  window.__flaviaCardMinimum = true;

  const MIN_CARDS = 10;
  const root = window.Shopify?.routes?.root || '/';
  const cartJsonUrl = root + 'cart.js';
  let lastState = { cardQty: 0, hasCards: false, blocked: false };
  let refreshTimer = null;

  const injectStyles = () => {
    if (document.getElementById('fi-card-minimum-style')) return;
    const style = document.createElement('style');
    style.id = 'fi-card-minimum-style';
    style.textContent = `
      .fi-card-minimum-product,
      .fi-card-minimum-cart {
        border: 1px solid rgba(var(--color-foreground), .16);
        border-radius: 10px;
        background: rgba(var(--color-foreground), .035);
        padding: 14px 16px;
        margin: 12px 0 16px;
        line-height: 1.45;
      }
      .fi-card-minimum-product strong,
      .fi-card-minimum-cart strong {
        display: block;
        font-size: 1.05em;
        margin-bottom: 5px;
      }
      .fi-card-minimum-product span {
        display: block;
        margin-top: 5px;
      }
      .fi-card-minimum-cart[data-ready="true"] {
        border-color: rgba(var(--color-foreground), .28);
      }
      .fi-card-minimum-cart__count {
        display: block;
        margin-bottom: 4px;
      }
      .fi-card-minimum-checkout-blocked {
        opacity: .55 !important;
        cursor: not-allowed !important;
      }
      [data-fi-card-minimum-hidden="true"] {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  };

  const isGreetingCard = item =>
    String(item?.product_type || '').trim().toLowerCase() === 'greeting card';

  const getCardQty = cart =>
    (cart?.items || []).reduce((sum, item) => sum + (isGreetingCard(item) ? Number(item.quantity || 0) : 0), 0);

  const messageHtml = cardQty => {
    const remaining = Math.max(0, MIN_CARDS - cardQty);
    if (remaining > 0) {
      return `<strong class="fi-card-minimum-cart__count">Build your Flavia card set: ${cardQty} of ${MIN_CARDS} cards selected</strong>
        Add ${remaining} more card${remaining === 1 ? '' : 's'} to checkout.<br>
        Every card is handmade in Switzerland. Swiss Post charges a <b>$12 flat postal/export fee per order</b>, plus actual shipping.`;
    }
    return `<strong class="fi-card-minimum-cart__count">You're ready to checkout — ${cardQty} cards selected.</strong>
      Your cards are handmade in Switzerland. Swiss Post charges a <b>$12 flat postal/export fee per order</b>, plus actual shipping.`;
  };

  const checkoutButtons = () =>
    [...document.querySelectorAll('button[name="checkout"], #checkout, #CartDrawer-Checkout')];

  const expressCartElements = () =>
    [...document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons, shopify-accelerated-checkout-cart')];

  const ensureMessage = (button, state) => {
    const cta = button.closest('.cart__ctas') || button.parentElement;
    if (!cta) return;
    let box = cta.previousElementSibling;
    if (!box || !box.matches('[data-fi-card-minimum-cart]')) {
      box = document.createElement('div');
      box.className = 'fi-card-minimum-cart';
      box.setAttribute('data-fi-card-minimum-cart', '');
      cta.parentNode.insertBefore(box, cta);
    }
    box.dataset.ready = state.blocked ? 'false' : 'true';
    const html = messageHtml(state.cardQty);
    if (box.innerHTML !== html) box.innerHTML = html;
  };

  const removeMessages = () => {
    document.querySelectorAll('[data-fi-card-minimum-cart]').forEach(el => el.remove());
  };

  const applyState = state => {
    lastState = state;
    injectStyles();

    checkoutButtons().forEach(button => {
      if (state.hasCards) ensureMessage(button, state);

      if (state.blocked) {
        if (!button.disabled) button.dataset.fiCardMinimumManaged = 'true';
        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
        button.classList.add('fi-card-minimum-checkout-blocked');
      } else if (button.dataset.fiCardMinimumManaged === 'true') {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        button.classList.remove('fi-card-minimum-checkout-blocked');
        delete button.dataset.fiCardMinimumManaged;
      } else {
        button.classList.remove('fi-card-minimum-checkout-blocked');
      }
    });

    expressCartElements().forEach(el => {
      if (state.blocked) {
        el.dataset.fiCardMinimumHidden = 'true';
      } else if (el.dataset.fiCardMinimumHidden === 'true') {
        delete el.dataset.fiCardMinimumHidden;
      }
    });

    if (!state.hasCards) removeMessages();
  };

  const refresh = async () => {
    try {
      const res = await fetch(cartJsonUrl, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        cache: 'no-store'
      });
      if (!res.ok) return;
      const cart = await res.json();
      const cardQty = getCardQty(cart);
      applyState({
        cardQty,
        hasCards: cardQty > 0,
        blocked: cardQty > 0 && cardQty < MIN_CARDS
      });
    } catch (_) {}
  };

  const scheduleRefresh = (delay = 250) => {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, delay);
  };

  document.addEventListener('click', event => {
    const checkout = event.target.closest('button[name="checkout"], #checkout, #CartDrawer-Checkout, a[href*="/checkout"]');
    if (checkout && lastState.blocked) {
      event.preventDefault();
      event.stopPropagation();
      checkoutButtons()[0]?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (event.target.closest('button[name="add"], cart-remove-button, .quantity__button, .quick-add__submit')) {
      scheduleRefresh(500);
      setTimeout(refresh, 1000);
    }
  }, true);

  document.addEventListener('change', event => {
    if (event.target.matches('input.quantity__input, input[name="updates[]"]')) {
      scheduleRefresh(500);
      setTimeout(refresh, 1000);
    }
  }, true);

  document.addEventListener('submit', event => {
    const submitter = event.submitter;
    if (lastState.blocked && (submitter?.name === 'checkout' || submitter?.id === 'checkout' || submitter?.id === 'CartDrawer-Checkout')) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  const observer = new MutationObserver(() => scheduleRefresh(180));
  const start = () => {
    injectStyles();
    refresh();
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();